import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { StyledConfirmDialog } from "../../styled/Dialogs";
import CircularLoading from "../loading/CircularLoading";

const ConfirmDialog = ({
  open,
  handleClose,
  handleConfirm,
  title,
  text,
  warningText,
  loading,
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <StyledConfirmDialog.TitleContainer>{title}</StyledConfirmDialog.TitleContainer>
      <StyledConfirmDialog.DialogContent>
        <Typography>
          <strong>{text}</strong>
        </Typography>
        <Typography>{warningText}</Typography>
      </StyledConfirmDialog.DialogContent>
      {loading ? (
        <StyledConfirmDialog.LoadingContainer>
          <CircularLoading />
        </StyledConfirmDialog.LoadingContainer>
      ) : (
        <StyledConfirmDialog.DialogContentContainer>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleConfirm} color="primary" variant="contained">
            Aceptar
          </Button>
        </StyledConfirmDialog.DialogContentContainer>
      )}
    </Dialog>
  );
};

export default ConfirmDialog;
